import { Link } from "react-router-dom";
import "../../assets/styles/pages/public/notfound.css";

export default function NotFound() {
    return (
        <div className="notFoundPage">
            <div className="notFoundPage__content">
                <div className="notFoundPage__illustration">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 500 500"
                        className="notFoundPage__svg"
                    >
                        <circle cx="250" cy="250" r="200" fill="#EAF8F4" />
                        <path
                            d="M250 150 Q270 180 250 210 Q230 180 250 150Z"
                            fill="#0D977C"
                        />
                        <circle cx="200" cy="220" r="12" fill="#0D977C" />
                        <circle cx="300" cy="220" r="12" fill="#0D977C" />
                        <path
                            d="M200 300 Q250 340 300 300"
                            stroke="#0D977C"
                            strokeWidth="5"
                            fill="none"
                        />
                    </svg>
                </div>

                <h1 className="notFoundPage__title">404</h1>
                <h2 className="notFoundPage__subtitle">Oops! Page Not Found</h2>
                <p className="notFoundPage__text">
                    The page you’re looking for might have been removed, had its name changed,
                    or is temporarily unavailable.
                </p>

                <Link to="/" className="notFoundPage__button">
                    Go Back Home
                </Link>
            </div>
        </div>
    );
}